
  const awsExports=
  {
  Auth:{
      'userPoolId': process.env.REACT_APP_COGNITO_USER_ID,
      'userPoolWebClientId':process.env.REACT_APP_COGNITO_CLIENT_ID
  }
  }
  export default awsExports;
